export const CreateSpaceTagRepository = Symbol('CreateSpaceTagRepository');
export const UpdateSpaceTagRepository = Symbol('UpdateSpaceTagRepository');
export const QuerySpaceTagsRepository = Symbol('QuerySpaceTagsRepository');
export const DeleteSpaceTagRepository = Symbol('DeleteSpaceTagRepository');
